import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import AgentChat from "@/components/agent/AgentChat";
import PraiseLogo from "@/components/PraiseLogo";
import { Link } from "react-router-dom";

const Agent = () => {
  const { user, profile, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !user) navigate("/auth");
  }, [user, isLoading, navigate]);

  useEffect(() => {
    if (!isLoading && profile && !profile.onboarding_completed) navigate("/onboarding");
  }, [profile, isLoading, navigate]);

  if (isLoading || !user) return null;

  return (
    <div className="flex flex-col h-dvh bg-background">
      <header className="flex items-center justify-between px-4 h-12 border-b border-border bg-background/80 backdrop-blur-md">
        <Link to="/" className="flex items-center gap-2">
          <PraiseLogo size={22} />
          <span className="text-sm font-semibold gradient-brand-text">Praise</span>
        </Link>
        <div className="flex items-center gap-3">
          {profile && (
            <span className="docket-tag">
              {profile.credits_remaining} credits
            </span>
          )}
          <Link to="/dashboard" className="specimen-label hover:text-foreground transition-colors">
            Library
          </Link>
        </div>
      </header>

      <main className="flex-1 overflow-hidden">
        <AgentChat />
      </main>
    </div>
  );
};

export default Agent;
